/**
 * Extracts a human-readable message from an unknown thrown value.
 *
 * Handles `Error` instances, plain objects with a `message` string, JSON:API
 * error arrays (`errors[0].message` or `errors[0].title`), and falls back to
 * a generic string.
 */
export function extractErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
  if (!error) return fallback;

  if (error instanceof Error) return error.message;

  if (typeof error === 'string') return error;

  if (typeof error === 'object' && error !== null) {
    const err = error as { errors?: Array<{ message?: string; title?: string }>; message?: string };

    if (Array.isArray(err.errors) && err.errors.length > 0) {
      return err.errors.map(e => e.message || e.title || fallback).join(', ');
    }

    if (typeof err.message === 'string') return err.message;
  }

  return fallback;
}
